import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DictionaryService
{
  private dictionaries = new BehaviorSubject<{ [key: string]: any }>({});

  constructor(private http: HttpClient) { }

  loadDictionary(locale: string)
  {
    if (!this.dictionaries.value[locale])
    {
      this.http.get(`assets/dictionary/${locale}.json`).pipe(
        catchError((error) =>
        {
          console.error(`Error loading dictionary for locale ${locale}:`, error);
          return of({});
        })
      ).subscribe(data =>
      {
        const newDictionaries = { ...this.dictionaries.value, [locale]: data };
        this.dictionaries.next(newDictionaries);
      });
    }
  }

  getDictionary(locale: string)
  {
    this.loadDictionary(locale);
    return this.dictionaries.asObservable();
  }
}
